import { alpha } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";
import Iconify from "../iconify";
import Label from "../label";
import { fDateTime } from "../../utils/formatTime";

// ----------------------------------------------------------------------

export type SignedOffBannerProps = {
  signedBy?: string | null;
  signedAt?: string | Date | null;
  sx?: SxProps<Theme>;
};

const FALLBACK_SIGNER = "Practitioner";

export default function SignedOffBanner({
  signedBy,
  signedAt,
  sx,
}: SignedOffBannerProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{
        p: 2,
        borderRadius: 1.5,
        border: (theme) =>
          `1px solid ${alpha(theme.palette.success.main, 0.24)}`,
        bgcolor: (theme) => alpha(theme.palette.success.main, 0.08),
        ...sx,
      }}
    >
      <Iconify
        icon="eva:checkmark-circle-2-fill"
        width={24}
        sx={{ color: "success.main", flexShrink: 0 }}
      />

      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography variant="subtitle2" noWrap>
          Signed off by {signedBy || FALLBACK_SIGNER}
        </Typography>

        {signedAt && (
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            {fDateTime(signedAt)}
          </Typography>
        )}
      </Box>

      <Label color="success" variant="soft" sx={{ flexShrink: 0 }}>
        Signed
      </Label>
    </Stack>
  );
}
